export class AsyncServiceBase {
    public static instances: Array<AsyncServiceBase> = [];
    constructor() {
        AsyncServiceBase.instances.push(this);
    }

    /*public async init(): Promise<any> {
        let childServicePromises: Array<Promise<any>> = [];
        childServicePromises.push(this.initializePromise);
        for (let key in this) {
            let child = this[key];
            if (child instanceof AsyncServiceBase) {
                childServicePromises.push(child.initializePromise);
                childServicePromises.push(child.init());
            }
        }
        return Promise.all(childServicePromises);
    }*/

    public initializeResolve: Function;
    public initializePromise = new Promise((resolve) => {
        this.initializeResolve = resolve;
    });

    public static reset() {
        for (let item of AsyncServiceBase.instances) {
            item.initializePromise = new Promise((resolve) => {
                item.initializeResolve = resolve;
            });
        }
    }
}
